import { createDocument, getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import { Select } from "styled";
import axios from 'apis/axios'
import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { BiCloudDownload } from "react-icons/bi";
import { useQuery } from "react-query";
import ReactSelect from "react-select";
import { TD, TH } from "styled/table";
import exportExcel from "utils/exportExcel";
import Modal from "components/Modal";
import {Button} from 'styled'
import toast from 'react-hot-toast';
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

const contractTypeOptions = [
  { value: 'All', label: 'All' },
  { value: 'CPKM', label: 'CPKM' },
  { value: 'NON CPKM', label: 'NON CPKM' }
];

const POLL_INTERVAL_MS = 1500;
const PROGRESS_POLL_MAX_AGE_MS = 15 * 60 * 1000;

const FleetStockDetails = () => {
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [data, setData] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [fleetMap, setFleetMap] = useState({});
  const [downloading, setDownloading ] = useState(false)
  const [contractType, setContractType] = useState("All");
  const [reportType , setReportType] = useState('fleet')
  const [reportData, setReportData] = useState({})
  const [stdDevRange, setStdDevRange] = useState([0, 30]);
  const [stdDevCount, setStdDevCount] = useState(0);
  const [showSlider, setShowSlider] = useState(true);
  const [downloadingFiltered, setDownloadingFiltered] = useState(false);
  const [selectedReportType, setSelectedReportType] = useState('fleet');
  const [downloadProgress, setDownloadProgress] = useState(null);
  const pollRef = useRef(null); 

  const getData = async ()=>{
    setIsLoading(true)
    setReportType(selectedReportType);
    const dt = await  createDocument("/report/fleetStockDetails", {
      ...(selectedFleets?.includes("all")
        ? {
          fleets: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
          .map((item) => item.value)
              .join(","),
          }
        : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
      ...(selectedHubs?.includes("all")
        ? {
            hubs: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
              .map((item) => item.value)
              .join(","),
          }
        : selectedHubs.length && {
            hubs: selectedHubs.map((hub) => hub).join(","),
          }),
      ...(contractType && contractType!== "All" &&  {
        contractType: contractType
      }),
      reportType: selectedReportType,
      // ...(stdDevRange[0] !== 0 || stdDevRange[1] !== 30 ? { stdDevRange } : {})
        })

    // //console.log(dt)
    console.log('dt--',dt);
    
    setData(dt);
    // setStdDevCount(dt?.totalObj?.stdDevCount || 0);
    setIsLoading(false)

  }
  const getDownloadData = async ()=>{
    setDownloading(true)
    try{
    const dt = await  createDocument("/report/fleetStockDetailsGlobalDownload", {
      ...(selectedFleets?.includes("all")
        ? {
          fleets: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
          .map((item) => item.value)
              .join(","),
          }
        : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
      ...(selectedHubs?.includes("all")
        ? {
            hubs: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
              .map((item) => item.value)
              .join(","),
          }
        : selectedHubs.length && {
            hubs: selectedHubs.map((hub) => hub).join(","),
          }),
          reportType: selectedReportType, 
      ...(contractType && contractType!== "All" &&  {
        contractType: contractType
      }),
      // ...(stdDevRange[0] !== 0 || stdDevRange[1] !== 30 ? { stdDevRange } : {})
    })

    let exportData = 
      dt?.data?.map((x, idx) => ({
      "Fleet Name": x.fleetName + " (" + x.fleetCity + ")",
      ...reportType === "hub" && {"Hub Name": x.hubName},
      "ITM": x.new ?? 0,
      "REUSE": x.reuse ?? 0,
      "CASING": x.casing ?? 0,
      "REPAIR": x.repair ?? 0,
      "IN TRANSIT": x.inTransit ?? 0,
      "RETREAD": x.retread ?? 0,
      "SCRAP": x.scrap ?? 0,
      "MISSING": x.missing ?? 0,
      "ON WHEEL": x.fitted ?? 0,
      "TOTAL TYRES": x.tyres ?? 0,
      }
    ), )

    exportData.push({
      "ITM": dt?.totalObj?.newCount ?? 0,
      "REUSE": dt?.totalObj?.reuseCount ?? 0,
      "CASING": dt?.totalObj?.casingCount ?? 0,
      "REPAIR": dt?.totalObj?.repairCount ?? 0,
      "IN TRANSIT": dt?.totalObj?.inTransitCount ?? 0,
      "RETREAD": dt?.totalObj?.retreadCount ?? 0,
      "SCRAP": dt?.totalObj?.scrapCount ?? 0,
      "MISSING": dt?.totalObj?.missingCount ?? 0,
      "ON WHEEL": dt?.totalObj?.fittedCount ?? 0,
      "TOTAL TYRES": dt?.totalObj?.totalTyres ?? 0,
    });
      
    exportExcel(exportData, "fleetstock-details", true, reportType === "hub" ? 2 : 1)

    }catch(err){

    }
    setDownloading(false)

  }

  const pollDownloadProgress = useCallback((requestId, startedAt) => {
    if (pollRef.current) clearInterval(pollRef.current);
    const poll = async () => {
      if (Date.now() - startedAt > PROGRESS_POLL_MAX_AGE_MS) {
        if (pollRef.current) clearInterval(pollRef.current);
        setDownloadProgress((p) => (p?.requestId === requestId ? null : p));
        return;
      }
      try {
        const res = await axios.get(`mail-logger/fleetstockdownloads/progress/${requestId}`);
        const d = res.data?.data;
        setDownloadProgress((prev) =>
          prev?.requestId === requestId
            ? { ...prev, ...d, progressPercent: d?.progressPercent ?? 0, progressMessage: d?.progressMessage ?? prev?.progressMessage }
            : prev
        );
        if (d?.emailSent === true || d?.progressPercent >= 100) {
          if (pollRef.current) clearInterval(pollRef.current);
          toast.success("Report sent to your email.");
          setTimeout(() => setDownloadProgress((p) => (p?.requestId === requestId ? null : p)), 2500);
          return;
        }
        if (d?.error) {
          if (pollRef.current) clearInterval(pollRef.current);
          toast.error(d.error || "Download failed.");
          setTimeout(() => setDownloadProgress((p) => (p?.requestId === requestId ? null : p)), 1500);
        }
      } catch {
        // keep polling on transient errors
      }
    };
    poll();
    pollRef.current = setInterval(poll, POLL_INTERVAL_MS);
  }, []);

  useEffect(() => {
    return () => {
      if (pollRef.current) clearInterval(pollRef.current);
    };
  }, []);

  const getDownloadTyreData = async () => {
    setDownloadProgress({ requestId: null, progressPercent: 0, progressMessage: "Initiating..." });
    try {
      const res = await axios({
        method: "post",
        data: {
          ...(selectedFleets?.includes("all")
            ? {
                fleets: getFleetOptions()
                  .filter((item) => item.value !== "all" && item.value !== "clear")
                  .map((item) => item.value)
                  .join(","),
              }
            : selectedFleets.length && {
                fleets: selectedFleets.join(","),
              }),
          ...(selectedHubs?.includes("all")
            ? {
                hubs: getHubOptions()
                  .filter((item) => item.value !== "all" && item.value !== "clear")
                  .map((item) => item.value)
                  .join(","),
              }
            : selectedHubs.length && {
                hubs: selectedHubs.join(","),
              }),
          reportName: "Fleet stock details",
          ...(contractType && contractType !== "All" && { contractType }),
        },
        url: "report/fleetStockDetails/download",
      });
      const requestId = res.data?.requestId;
      if (requestId) {
        setDownloadProgress({
          requestId,
          progressPercent: 10,
          progressMessage: "Report queued...",
        });
        pollDownloadProgress(requestId, Date.now());
      } else {
        toast.success(res.data?.message ?? "Request submitted.");
        setDownloadProgress(null);
      }
    } catch (err) {
      setDownloadProgress(null);
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message ||
        "Something went wrong";
      toast.error(msg);
    }
  };

  const { data: allFleets } = useQuery(["/customer-fleet"], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  const { data: allHubs } = useQuery(["/customer-hub"], () =>
    getAllData("/customer-hub", {
      limit: 3000,
    })
  );

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
       ...selectedFleets?.length ? [{
          label: "All",
          value: "all",
        }]: [],
        ...selectedFleets?.length ? [{
          label: "Clear",
          value: "clear",
        }]: [],
        ...(selectedFleets?.includes("all") ? 
        allHubs?.data?.length &&
          allHubs?.data
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            }) : 
        allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              );

              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  const setFleetMapData = useCallback(() => {
    let selectedFleetCodes = allFleets?.data?.map((fleet) => fleet.fleetCode);
    let selectedHubsData = [];
    if (selectedHubs?.includes("all"))
      selectedHubsData = allHubs?.data?.filter((hub) =>
        selectedFleetCodes?.includes(hub.fleetCode)
      );
    else
      selectedHubsData = allHubs?.data?.filter((hub) =>
        selectedHubs?.includes(hub._id)
      );
    const mp = {};
    selectedHubsData.map((hub) => {
      if (selectedFleetCodes?.includes(hub.fleetCode)) {
        if (mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
        mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
      }
    });

    setFleetMap({...mp});
  }, [allFleets?.data, allHubs?.data, selectedHubs])

  return (
    <div>
       <div className="w-full px-7 flex-col justify-center items-center  gap-1">

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-3">
          <label className="w-full py-3">
            Select Fleets
            <ReactSelect  
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getFleetOptions()}
              value={
                selectedFleets &&
                selectedFleets?.map((fleet) => {
                  return {
                    value: fleet,
                    label: getFleetOptions()?.find((item) => item?.value === fleet)
                      ?.label,
                  };
                })
              }
              onChange={(value) => {
                let allValues = value?.map((item) => item.value);
                if(allValues?.includes("clear")){
                  // console.log(allValues)
                  setSelectedFleets([]);
                  setSelectedHubs([]);
                  return;
                }
                if(!selectedFleets?.includes("all") && allValues.includes("all")){
                  setSelectedFleets(["all"]);
                  return;
                }

                if (selectedFleets.includes("all")) {
                  // console.log("first");
                  // console.log(getFleetOptions())
                  value = value.filter(item => item.value!== "all")
                }

                let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                  value?.map((item) => item.value)?.includes(fleet._id)
                );

                let selectedHubsVal = allHubs?.data?.filter((hub) =>
                  selectedHubs?.map((item) => item)?.includes(hub._id)
                );
                
                setSelectedHubs(
                  selectedHubsVal
                    ?.filter((hub) =>
                      selectedFleetsVal?.find(
                        (fleet) => fleet.fleetCode === hub.fleetCode
                      )
                    )
                    .map((hub) => hub._id)
                );

                // console.log({allHubs, selectedHubs})
                
                setSelectedFleets(value.map((fleet) => fleet.value));
                }
            }
              name="fleets"
              isMulti = {true}
            />
          </label>
          <label className="w-full py-3">
            Select Hubs
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getHubOptions()}
              value={
                selectedHubs &&
                selectedHubs?.map((hub) => {
                  // console.log({hub})
                  return {
                    value: hub,
                    label: getHubOptions()?.find((item) => item.value === hub)
                      ?.label,
                  };
                })
              }
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);
                // console.log({allValues})
                if(allValues.includes("clear")){
                  setSelectedHubs([])
                  return;
                }
                if (!selectedHubs?.includes("all") && allValues.includes("all")) {
                  setSelectedHubs(["all"])
                } 
                else {
                  // console.log({value})
                  value = value.filter(value => value.value!== "all")
                  // console.log({value})
                  let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                    selectedFleets?.includes(fleet._id)
                  )?.map(fleet=>fleet.fleetCode);
                  // console.log({allValues})
                
                  const selectedHubsData = allHubs?.data?.filter(hub=> allValues?.includes(hub._id))
                  setSelectedHubs(value.map((hub) => hub.value));
                }
              }}
              name="hubs"
              isMulti={true}
            />
          </label>

        <label className="w-full py-3">
            Contract Type 
            <ReactSelect
           styles={{
            control: (base, state) => ({
              ...base,
              borderColor: 'transparent',
              minWidth: '100%',
              '&:hover': {
                borderColor: 'rgb(34 197 94)',
              },
            }),
          }}
            name="contractType"
            className="shadow-md rounded-md py-1 mb-2"
            value={contractTypeOptions.find(option => option.value === contractType)} 
            onChange={(option) => {
              setContractType(option.value);
            }}
            options={contractTypeOptions}
          />
          </label>

          <label className="w-full py-3">
            Report Type
            <Select
              name="reportType"
              value={selectedReportType}
              onChange={(e) => setSelectedReportType(e.target.value)}
              >
              <option value={"fleet"}>Fleet Wise</option>
              <option value={"hub"}>Hub Wise</option>
            </Select>
          </label>

          </div>

      <div className="grid sm:grid-cols-3 lg:grid-cols-6 items-center">

      
          <div className="col-span-3 mt-3 flex flex-row items-start justify-start gap-x-3 ">
            <Button className=' col-span-1 mt-5 mx-2 h-10' type="button" disabled={(!selectedHubs.length)} bgPrimary onClick={() => {
              setFleetMapData();
              getData()
            }} >
              Search
            </Button>

            {downloading ? 'Downloading count...' : selectedHubs.length !== 0 && <Button
              className=" col-span-1  mt-5 h-10 text-sm text-green-500 hover:scale-105 cursor-pointer text-center"
              onClick={() => {
                getDownloadData()
              }}
            >Download Count</Button>}

            {downloadingFiltered ? "Downloading data..." : selectedHubs.length !== 0 && <Button
              className="col-span-1 mt-5 h-10 text-sm text-green-500 hover:scale-105 cursor-pointer text-center"
              onClick={getDownloadTyreData}
              disabled={!!downloadProgress?.requestId}
            >Download Data</Button>}

            {downloadProgress?.requestId && (
              <div className="col-span-full mt-3 w-full max-w-md rounded-lg border border-gray-200 bg-white p-3 shadow-sm">
                <p className="mb-1 text-sm font-medium text-gray-700">Fleet Stock Details – generating report</p>
                <div className="h-2 w-full overflow-hidden rounded-full bg-gray-200">
                  <div
                    className="h-full rounded-full bg-green-500 transition-all duration-300"
                    style={{ width: `${Math.min(100, Math.max(0, downloadProgress.progressPercent ?? 0))}%` }}
                  />
                </div>
                <p className="mt-1 text-xs text-gray-500">{downloadProgress.progressMessage ?? "Please wait..."}</p>
              </div>
            )}

          </div>

      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200 text-center">
                  <thead className="bg-gray-50">
                    <tr>
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">Fleet Name</TH>
                      {reportType === 'hub' && data?.data[0]?.hubName  ? <TH scope="col">Hub Name</TH> : <></>}
                      <TH scope="col">ITM</TH>
                      <TH scope="col">Reuse</TH>
                      <TH scope="col">Casing</TH>
                      <TH scope="col">Repair</TH>
                      <TH scope="col">In Transit</TH>
                      <TH scope="col">Retread</TH>
                      <TH scope="col">Scrap</TH>
                      <TH scope="col">Missing</TH>
                      <TH scope="col">On Wheel</TH>
                      <TH scope="col">Total Tyres</TH>
                      {/* <TH scope="col">Total Tyres</TH> */}
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {data &&
                      data?.data?.map((d, idx) => {
                        console.log('dataValue--',d);
                       return <ViewList data={d} idx={idx} hubId = {d.hubId} fleetId = {allFleets?.data?.find(fleet=> fleet.fleetCode === d.fleetCode)?._id} fleetMap = {fleetMap} contractType = {contractType} reportType={reportType}
                      //  stdDevRange={stdDevRange}
                       />
})}
                  </tbody>
                  {data?.totalObj? <tfoot>
                    <tr className="text-gray-600 font-semibold bg-green-100">
                      <TD></TD>
                      <TD colSpan={ reportType === 'hub' &&  data?.data[0]?.hubName  ?  2 : 1} className="text-left">
                        TOTAL
                      </TD>
                      <TD className="text-center">
                        {data?.totalObj?.newCount}
                      </TD>
                      <TD className="text-center">
                        {data?.totalObj?.reuseCount}
                      </TD>
                      <TD className="text-center">
                        {data?.totalObj?.casingCount}
                      </TD>
                      <TD className="text-center">
                        {data?.totalObj?.repairCount}
                      </TD>
                      <TD className="text-center">
                        {data?.totalObj?.inTransitCount ?? 0}
                      </TD>
                      <TD className="text-center">
                        {data?.totalObj?.retreadCount}
                      </TD>
                      <TD className="text-center">
                        {data?.totalObj?.scrapCount}
                      </TD>
                      <TD className="text-center">
                        {data?.totalObj?.missingCount}
                      </TD>
                      <TD className="text-center">
                        {data?.totalObj?.fittedCount}
                      </TD>
                      <TD className="text-center">
                        {data?.totalObj?.totalTyres}
                      </TD>
                    </tr>
                  </tfoot> : <></>}
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
    </div>
  );
};

export default FleetStockDetails;

const ViewList = ({ data, idx, fleetId, hubId, fleetMap, contractType , reportType,
  // stdDevRange
 }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [fleet, setFleet] = useState("")
  const [isLoading, setIsLoading] = useState(true)
  const [modalQueryProp, setModalQueryProp] = useState(null);

  const getModalData = async (modalQueryProp,fleetId,hubId) => {
    console.log('modalQueryProp--',modalQueryProp,fleetId,hubId,contractType);
    setShowModal(true)
    if (modalQueryProp) {
      setIsLoading(true);
      const dt = await createDocument("/report/fleetStockDetails/modalInfo",{
        fleets: modalQueryProp?.fleetId,
        hubs: Array.isArray(modalQueryProp?.hubId) ? modalQueryProp.hubId.join(',') : modalQueryProp?.hubId,
        ...(contractType && contractType!== "All" &&  {
          contractType: modalQueryProp?.contractType
        }),
        reportType,
        status:modalQueryProp?.status,
        // ...(stdDevRange[0] !== 0 || stdDevRange[1] !== 30 ? { stdDevRange } : {})
          })
      setModalData(dt);
      setModalQueryProp(modalQueryProp);
    }
    setIsLoading(false);
  }

  const downloadDiv = (data, fleetName, hubId = "", fleetCode, status, contractType )=>{
    console.log('contractType--',contractType);
    return data?.length!==0  ? <div className="flex gap-2 items-center justify-center text-center">
    <span
      className="hover:text-green-500 cursor-pointer"
      onClick={() => {
        getModalData({data:data,contractType, title: "Fleet Stock Details "+ status, fleetCode,fleetId,hubId, fleetName, fleetMap, hubId, status}); setFleet(fleetName)
      
      }}
    >
      {data ?? 0}
    </span>
  </div>: <div className="text-center"> 0</div>
  }
  
  return (
    <Fragment>

      {showModal && (
        <Modal
          handleClick={() => setShowModal(false)}
          title={modalQueryProp?.title}
          className="max-w-2xl"
        >
          {isLoading ? <Spinner /> : <>
          {/* <h1>This is the modal</h1> */}
          <h1 className="w-full flex justify-end text-end px-2 my-1">

            <Button
              onClick={() => {
                const myPromise = axios({
                  method: 'post',
                  data: {
                      hubs: modalQueryProp.hubId 
                        ? modalQueryProp.hubId.toString() 
                        : (fleetMap[modalQueryProp?.fleetCode]?.length 
                            ? fleetMap[modalQueryProp.fleetCode].join(",") 
                            : ""),
                      ...(fleetId ? { fleets: fleetId.toString() } : {}),
                    ...(modalQueryProp.status!== "" && {
                      status: modalQueryProp.status 

                    }),
                    ...(contractType && contractType!== "All" &&  {
                      contractType: contractType
                    }),

                    reportName:  "Fleet stock details"  

                  },
                  url: "report/fleetStockDetails/download",
                });
        
                toast.promise(myPromise, {
                  loading: 'Request Initiated, Please Hold on',
                  success: (dt) => {
                    return dt.data.message;
                  },
                  error: (err) =>{
                    // //console.log({err});
                    return err?.response?.data.error ||
                    err?.response?.data.message ||
                    err?.message ||
                    'Something went wrong'},
                },
                {
                  success: {
                    duration: 3000,
                    icon: '📩',
                  },
                });
                      }}
              className=" text-blue-500 hover:scale-105 cursor-pointer text-right"
            >
              Download
            </Button>

          </h1>
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <TH scope="col">S.N.</TH>
                <TH scope="col">Fleet Name</TH>
                { reportType === 'hub' ? <TH scope="col">Hub Name</TH> : <></>}
                <TH scope="col">Stencil Number</TH>
                <TH scope="col">Status</TH>
                <TH scope="col">Avg NSD</TH>
                {/* <TH scope="col">Standard Deviation</TH> */}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {modalData &&
                modalData?.data?.length > 0 &&
                modalData?.data?.map((tyre, index) => {
                  console.log('tyre--',tyre);
                  
                 return <tr>
                    <TD>{index + 1}</TD>
                    <TD>{fleet} ({tyre.fleet?.city})</TD>
                    { reportType === 'hub' ?<TD>{data.hubName}</TD> : <></>}
                    <TD>{tyre.stencilNo}</TD>
                    <TD>{tyre.status === "FITTED"? "On Wheel": tyre.status}</TD>
                    <TD>{tyre.avgNSD!=="undefined" ? parseFloat(tyre.avgNSD ?? 0)?.toFixed(2): ""}</TD>
                    {/* <TD>{tyre.stdDevNSD.toFixed(2)}</TD> */}
                  </tr>
 })}
                
            </tbody>
            
          </table>
          </>}
        </Modal>
      )}
      <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{idx + 1}</TD>
        <TD className="text-left">{data?.fleetName} ({data?.fleetCity})</TD>
        { reportType === 'hub' && data?.hubName ? <TD className="text-left">{data?.hubName}</TD> : null } 
        {/* <TD>{data?.status}</TD> */}
        {/* itm scrap onwheel casing repair reuse retread */}
        <TD>
          { downloadDiv(data.new,data.fleetName, data.hubId, data.fleetCode, "READY_TO_FIT_OUT", contractType) }
        </TD>
        <TD>
          { downloadDiv(data.reuse,data.fleetName, data.hubId, data.fleetCode, "REUSE", contractType) }
        </TD>
        <TD>
          { downloadDiv(data.casing,data.fleetName, data.hubId, data.fleetCode, "CASING", contractType) }
        </TD>
        <TD>
          { downloadDiv(data.repair,data.fleetName, data.hubId, data.fleetCode, "REPAIR", contractType) }
        </TD>
        <TD>
          { downloadDiv(data.inTransit,data.fleetName, data.hubId, data.fleetCode, "IN_TRANSIT", contractType) }
        </TD>
        <TD>
          { downloadDiv(data.retread,data.fleetName, data.hubId, data.fleetCode, "RETREAD", contractType) }
        </TD>
        <TD>
          { downloadDiv(data.scrap,data.fleetName, data.hubId, data.fleetCode, "SCRAP", contractType) }
        </TD>
        <TD>
          { downloadDiv(data.missing,data.fleetName, data.hubId, data.fleetCode, "MISSING", contractType) }
        </TD>
        <TD>
          { downloadDiv(data.fitted,data.fleetName, data.hubId, data.fleetCode, "FITTED", contractType) }
        </TD>
        <TD>
          { downloadDiv(data.tyres,data.fleetName, data.hubId, data.fleetCode, "", contractType) }
        </TD>
        
      </tr>
    </Fragment>
  );
}